<template>
    <path fill-rule="evenodd" d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm0 30C8.28 30 2 23.718 2 16 2 8.28 8.28 2 16 2c7.718 0 14 6.28 14 14 0 7.718-6.282 14-14 14zm0-24a2 2 0 0 0-2 2v10a2 2 0 0 0 4 0V8a2 2 0 0 0-2-2zm2 17.968a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/>
</template>

<script>
export default {
    name: 'notificationErrorIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 32');
    }
};
</script>
